function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "223px",
    height: "224px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ec8109",
    d: "M 198.5,50.5 C 198.427,52.0269 199.094,53.0269 200.5,53.5C 215.113,75.9665 220.613,100.633 217,127.5C 207.167,178.667 176.667,209.167 125.5,219C 98.6331,222.613 73.9665,217.113 51.5,202.5C 51.0269,201.094 50.0269,200.427 48.5,200.5C 11.5246,173.127 -3.30875,136.46 4,90.5C 6.55866,76.9679 11.7253,64.6346 19.5,53.5C 20.9063,53.0269 21.573,52.0269 21.5,50.5C 47.1711,15.5121 81.8378,0.345397 125.5,5C 156.37,10.0812 180.704,25.2479 198.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#6f3e0a",
    d: "M 21.5,50.5 C 21.573,52.0269 20.9063,53.0269 19.5,53.5C 19.427,51.9731 20.0937,50.9731 21.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#6f3e0a",
    d: "M 198.5,50.5 C 199.906,50.9731 200.573,51.9731 200.5,53.5C 199.094,53.0269 198.427,52.0269 198.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffdfb",
    d: "M 104.5,55.5 C 121.478,54.3979 132.978,61.7312 139,77.5C 141.855,96.2941 134.355,108.794 116.5,115C 98.2678,117.473 86.4344,109.973 81,92.5C 78.7576,73.6317 86.591,61.2983 104.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee8410",
    d: "M 105.5,73.5 C 116.642,72.4801 122.142,77.4801 122,88.5C 119.041,96.2296 113.541,99.0629 105.5,97C 94.889,89.1307 94.889,81.2974 105.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfc",
    d: "M 81.5,116.5 C 84.1873,116.336 86.854,116.503 89.5,117C 103.167,125.667 116.833,125.667 130.5,117C 141.572,115.403 145.405,119.903 142,130.5C 136.194,134.996 129.694,138.163 122.5,140C 128.667,146.167 134.833,152.333 141,158.5C 142.164,168.171 137.997,172.171 128.5,170.5C 122.181,164.682 116.014,158.682 110,152.5C 104.167,158.333 98.3333,164.167 92.5,170C 86.5402,172.868 82.0402,171.368 79,165.5C 78.289,163.101 78.4557,160.768 79.5,158.5C 85.3185,152.181 91.3185,146.014 97.5,140C 90.2587,138.296 83.7587,135.129 78,130.5C 75.2672,124.722 76.4339,120.056 81.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#6f3e0a",
    d: "M 48.5,200.5 C 50.0269,200.427 51.0269,201.094 51.5,202.5C 49.9731,202.573 48.9731,201.906 48.5,200.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/OK.794cae0b74f824ce616d876dceef152f.svg";
export { ForwardRef as ReactComponent };